import OriginalToggle from './Toggle.svelte';
import OriginalContentLeft from './ContentLeft.svelte';
import OriginalContentRight from './ContentRight.svelte';
import Label from './Label.svelte';
import Description from './Description.svelte';
import Icon from '../icon/Icon.svelte';
const Toggle = OriginalToggle;
Toggle.ContentLeft = OriginalContentLeft;
Toggle.ContentRight = OriginalContentRight;
Toggle.LeftIcon = Icon;
Toggle.RightIcon = Icon;
Toggle.ContentLeft.Label = Label;
Toggle.ContentLeft.Description = Description;
Toggle.ContentRight.Label = Label;
Toggle.ContentRight.Description = Description;
export default Toggle;
